import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { FileResolutionData } from '../../models/uploaded-image-resolution.model';
import * as actions from './files-resolution.actions';

export const adapter = createEntityAdapter<FileResolutionData>({
  selectId: (data) => data.name,
});

export type State = EntityState<FileResolutionData>;
export const initialState: State = adapter.getInitialState();

export const filesResolutionReducer = createReducer(
  initialState,
  on(actions.setFilesResolution, (state, { resolutionData }) => {
    return adapter.setAll(resolutionData, state);
  }),
  on(actions.removeFileResolution, (state, { name }) => {
    return adapter.removeOne(name, state);
  }),
  on(actions.removeAllFilesResolution, (state) => adapter.removeAll(state)),
  on(actions.updateFilesResolution, (state, { updates }) => adapter.updateMany(updates, state)),
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectFilesResolutionIds = selectIds;
export const selectFileResolutionEntities = selectEntities;
export const selectAllFilesResolution = selectAll;
